import { render, staticRenderFns } from "./claimExplanation.vue?vue&type=template&id=65c3444a&scoped=true&"
import script from "./claimExplanation.vue?vue&type=script&lang=js&"
export * from "./claimExplanation.vue?vue&type=script&lang=js&"
import style0 from "./claimExplanation.vue?vue&type=style&index=0&id=65c3444a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3444a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c3444a')) {
      api.createRecord('65c3444a', component.options)
    } else {
      api.reload('65c3444a', component.options)
    }
    module.hot.accept("./claimExplanation.vue?vue&type=template&id=65c3444a&scoped=true&", function () {
      api.rerender('65c3444a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/claimExplanation.vue"
export default component.exports